/* eslint-disable no-unused-vars */
/* eslint-disable no-eval */
/* eslint-disable no-new-func */
import { CORPORATE_ACTION_STOCK_TYPE, STOCK_TYPE } from 'constants/trading';

const calculatePriceFraction = (stockType, price) => {
  let priceFraction = 1;
  if (stockType && stockType.toLowerCase() === STOCK_TYPE.saham) {
    if (price > 200 && price <= 500) {
      priceFraction = 2;
    } else if (price > 500 && price <= 2000) {
      priceFraction = 5;
    } else if (price > 2000 && price <= 5000) {
      priceFraction = 10;
    } else if (price > 5000) {
      priceFraction = 25;
    }
  }
  return priceFraction;
};

const calculateFormula = (args, formula) =>
  new Function(args, `return ${formula}`)();

export const generateTradingVariableMain = (
  configFormula,
  lot,
  price,
  isStockCorporateActions,
) => {
  const {
    formula: {
      fee_buy,
      fee_sell,
      sell_amount_fee,
      sell_amount_invested,
      sell_amount_invested_fee,
      sell_amount_broker_fee,
      sell_amount_exchange_fee,
      ca_sell_amount_fee,
      ca_sell_amount_invested,
      ca_sell_amount_invested_fee,
      ca_sell_amount_broker_fee,
      ca_sell_amount_exchange_fee,
    },
    preview_fee: { broker_fee, exchange },
  } = configFormula;

  const LOT = Number(lot);
  const PRICE = Number(price);
  const FEE_BUY = Number(fee_buy);
  const FEE_SELL = Number(fee_sell);
  const BROKER_FEE = Number(broker_fee);
  const EXCHANGE_FEE_TOTAL_BUY = Number(exchange.exchange_fee_total_buy);
  const EXCHANGE_FEE_TOTAL_SELL = Number(exchange.exchange_fee_total_sell);

  let SELL_AMOUNT = eval(sell_amount_invested);
  let SELL_FEE = eval(sell_amount_fee);
  let SELL_AMOUNT_FEE = eval(sell_amount_invested_fee);
  let STOCKBIT_FEE = eval(sell_amount_broker_fee);
  let EXCHANGE_FEE = eval(sell_amount_exchange_fee);

  if (isStockCorporateActions) {
    SELL_AMOUNT = eval(ca_sell_amount_invested);
    SELL_FEE = eval(ca_sell_amount_fee);
    SELL_AMOUNT_FEE = eval(ca_sell_amount_invested_fee);
    STOCKBIT_FEE = eval(ca_sell_amount_broker_fee);
    EXCHANGE_FEE = eval(ca_sell_amount_exchange_fee);
  }

  return {
    SELL_AMOUNT,
    SELL_FEE,
    SELL_AMOUNT_FEE,
    STOCKBIT_FEE,
    EXCHANGE_FEE,
  };
};

export const generateTradingVariableGeneral = (
  configFormula,
  lot,
  price,
  price_average_fee,
  type = '',
) => {
  const stockType = type;
  const isStockCorporateActions =
    CORPORATE_ACTION_STOCK_TYPE.indexOf(stockType.toUpperCase()) > -1;
  const {
    formula: { buy_amount_invested, sell_profit_loss, sell_gain },
  } = configFormula;

  const LOT = Number(lot);
  const PRICE = Number(price);
  const { SELL_AMOUNT, SELL_FEE, SELL_AMOUNT_FEE, STOCKBIT_FEE, EXCHANGE_FEE } =
    generateTradingVariableMain(
      configFormula,
      LOT,
      PRICE,
      isStockCorporateActions,
    );

  const BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE = calculateFormula(
    `LOT=${LOT},PRICE=${price_average_fee}`,
    buy_amount_invested,
  );
  const SELL_PROFITLOSS = calculateFormula(
    `SELL_AMOUNT_INVESTED_FEE=${SELL_AMOUNT_FEE},BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE=${BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE}`,
    sell_profit_loss,
  );
  const SELL_GAIN = 100 * eval(sell_gain);

  const PRICE_FRACTION = calculatePriceFraction(stockType, PRICE);

  return {
    SELL_FEE,
    STOCKBIT_FEE,
    EXCHANGE_FEE,
    SELL_AMOUNT,
    SELL_AMOUNT_FEE,
    SELL_PROFITLOSS,
    SELL_GAIN,
    PRICE_FRACTION,
  };
};
